import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
 FaChartLine, 
 FaHistory, 
 FaMoneyBillWave, 
 FaWallet, 
 FaUserFriends,
 FaRss
} from 'react-icons/fa';

const BottomNavigation = () => {
 const location = useLocation();
 return (
   <div className="bottom-nav">
     <div className="nav-container">
       <Link
         to="/user-dashboard"
         className={`nav-item ${location.pathname === '/user-dashboard' ? 'active' : ''}`}
       >
         <div className="nav-icon">
           <FaChartLine />
         </div>
         <span className="nav-label">Portfolio</span>
       </Link>

       <Link
         to="/shares"
         className={`nav-item ${location.pathname === '/shares' ? 'active' : ''}`}
       >
         <div className="nav-icon">
           <FaMoneyBillWave />
         </div>
         <span className="nav-label">Buy Shares</span>
       </Link>
       
       <Link
         to="/history"
         className={`nav-item ${location.pathname === '/history' ? 'active' : ''}`}
       >
         <div className="nav-icon">
           <FaHistory />
         </div>
         <span className="nav-label">History</span>
       </Link>

       <Link
         to="/earnings"
         className={`nav-item ${location.pathname === '/earnings' ? 'active' : ''}`}
       >
         <div className="nav-icon">
           <FaWallet />
         </div>
         <span className="nav-label">Validations</span>
       </Link>

       <Link
         to="/team"
         className={`nav-item ${location.pathname === '/team' ? 'active' : ''}`}
       >
         <div className="nav-icon">
           <FaUserFriends />
         </div>
         <span className="nav-label">Team</span>
       </Link>

       <Link
         to="/feeds"
         className={`nav-item ${location.pathname === '/feeds' ? 'active' : ''}`}
       >
         <div className="nav-icon">
           <FaRss  />
         </div>
         <span className="nav-label">Feeds</span>
       </Link>
     </div>
     
     <style jsx>{`
       .bottom-nav {
         position: fixed;
         bottom: 0;
         left: 0;
         right: 0;
         z-index: 1000;
         background: rgba(16, 20, 31, 0.98);
         backdrop-filter: blur(20px);
         border-top: 1px solid rgba(255, 255, 255, 0.08);
         box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
       }
       
       .nav-container {
         display: flex;
         justify-content: space-evenly;
         align-items: center;
         padding: 8px 12px 12px;
         max-width: 600px;
         margin: 0 auto;
         position: relative;
       }
       
       .nav-item {
         display: flex;
         flex-direction: column;
         align-items: center;
         text-decoration: none;
         color: #64748b;
         transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
         padding: 8px 12px;
         border-radius: 12px;
         min-width: 0;
         flex: 1;
         position: relative;
         overflow: hidden;
       }
       
       .nav-item::before {
         content: '';
         position: absolute;
         top: 0;
         left: 50%;
         transform: translateX(-50%);
         width: 0;
         height: 2px;
         background: linear-gradient(90deg, #e74c3c, #c0392b);
         border-radius: 0 0 2px 2px;
         transition: width 0.3s ease;
       }
       
       .nav-item.active::before {
         width: 24px;
       }
       
       .nav-item:hover:not(.active) {
         color: #94a3b8;
         background: rgba(255, 255, 255, 0.02);
       }
       
       .nav-item.active {
         color: #e74c3c;
         background: rgba(231, 76, 60, 0.08);
       }
       
       .nav-icon {
         width: 36px;
         height: 36px;
         display: flex;
         align-items: center;
         justify-content: center;
         font-size: 16px;
         margin-bottom: 4px;
         border-radius: 10px;
         transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
         background: rgba(255, 255, 255, 0.02);
         border: 1px solid rgba(255, 255, 255, 0.05);
       }
       
       .nav-item.active .nav-icon {
         background: rgba(231, 76, 60, 0.12);
         border-color: rgba(231, 76, 60, 0.2);
         color: #e74c3c;
         transform: scale(1.05);
       }
       
       .nav-item:hover:not(.active) .nav-icon {
         background: rgba(255, 255, 255, 0.04);
         border-color: rgba(255, 255, 255, 0.08);
         transform: translateY(-1px);
       }
       
       .nav-label {
         font-size: 10px;
         font-weight: 500;
         letter-spacing: 0.2px;
         margin-top: 2px;
         text-align: center;
         white-space: nowrap;
         overflow: hidden;
         text-overflow: ellipsis;
         max-width: 60px;
         line-height: 1.2;
       }
       
       .nav-item.active .nav-label {
         color: #e74c3c;
         font-weight: 600;
       }
       
       /* Safe area for devices with home indicator */
       @supports (padding-bottom: env(safe-area-inset-bottom)) {
         .nav-container {
           padding-bottom: calc(12px + env(safe-area-inset-bottom));
         }
       }
       
       /* Mobile responsiveness */
       @media (max-width: 480px) {
         .nav-container {
           padding: 6px 8px 10px;
         }
         
         .nav-item {
           padding: 6px 8px;
         }
         
         .nav-icon {
           width: 32px;
           height: 32px;
           font-size: 15px;
           margin-bottom: 3px;
         }
         
         .nav-label {
           font-size: 9px;
           max-width: 50px;
         }
         
         .nav-item.active::before {
           width: 20px;
         }
       }
       
       @media (max-width: 400px) {
         .nav-container {
           padding: 5px 6px 8px;
         }
         
         .nav-item {
           padding: 5px 6px;
         }
         
         .nav-icon {
           width: 30px;
           height: 30px;
           font-size: 14px;
           margin-bottom: 2px;
         }
         
         .nav-label {
           font-size: 8px;
           max-width: 45px;
         }
         
         .nav-item.active::before {
           width: 18px;
         }
       }
       
       @media (max-width: 360px) {
         .nav-container {
           padding: 4px 4px 6px;
         }
         
         .nav-item {
           padding: 4px 3px;
         }
         
         .nav-icon {
           width: 28px;
           height: 28px;
           font-size: 13px;
           margin-bottom: 2px;
         }
         
         .nav-label {
           font-size: 7px;
           max-width: 40px;
         }
         
         .nav-item.active::before {
           width: 16px;
         }
       }
     `}</style>
   </div>
 );
};

export default BottomNavigation;
